export const ROOT = 'StepOne/form/typeVehicle';

export const FETCH_TYPE_VEHICLE_REQUEST = `${ROOT}/FETCH_TYPE_VEHICLE_REQUEST`;
export const FETCH_TYPE_VEHICLE_FAILURE = `${ROOT}/FETCH_TYPE_VEHICLE_FAILURE`;
export const FETCH_TYPE_VEHICLE_SUCCESS = `${ROOT}/FETCH_TYPE_VEHICLE_SUCCESS`;
